export const en = {
    'add-description': {
        one: 'Creative will be changed in {count} ad.',
        some: 'Creative will be changed in {count} ads.',
        many: 'Creative will be changed in {count} ads.',
        none: 'No appropriate replacement creatives for the ads selected.'
    },
    'duplicate-error': 'Only one image for each size can be selected for batch changes',
    warning:
        "The ad's creative can only be replaced with a creative of the same size and created the same way as the original."
};
